import { partial } from 'radash';

import { RxdbCollectionNameV2 } from '../RxdbCollectionNameV2';
import { ProgressRecorder } from '../Synchronizable/Synchronizable';
import { Success, success } from '../Synchronizable/SyncResult';
import { FamilyMember } from './FamilyMember';
import { ParentsFailed, reason } from './ParentsFailed';
import { recordFailedParent } from './recordFailedParent';

export async function waitForParents(
  sync: (familyMember: FamilyMember<unknown>) => Promise<Success>,
  familyMember: FamilyMember<unknown>,
  progress: ProgressRecorder,
): Promise<Success> {
  if (!familyMember.parents) return success;

  progress('Waiting for Parents');

  const failedParents: RxdbCollectionNameV2[] = [];
  const withFailedParents = partial(recordFailedParent, failedParents);
  const syncParent = partial(withFailedParents, sync);

  await Promise.allSettled(familyMember.parents.map(syncParent));

  if (failedParents.length > 0) {
    const parentsFailed: ParentsFailed = {
      failure: reason,
      failedParents,
    };
    // This is a perfectly fine object to indicate failure,
    // and throwing it is the way to reject the promise in an async function.
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw parentsFailed;
  }

  progress('Parent Sync Complete');
  return success;
}
